var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-2 bg-white border rounded" }, [
    _vm.currentJob.apiJob?.warnings[0].code === 20025
      ? _c("div", { staticClass: "alert alert-warning pt-4 mb-0" }, [
          _c("p", [
            _c("strong", { staticClass: "gap-10px d-flex" }, [
              _c("i", { staticClass: "lh-inherit far fa-info-circle" }),
              _vm._v(
                " \n        " +
                  _vm._s(_vm._f("trans")(_vm.getTranslatedError(20025))) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              {
                staticClass: "font-weight-bold text-info",
                attrs: { href: "#" },
                on: { click: _vm.openChangeOptions },
              },
              [_vm._v(_vm._s(_vm._f("trans")("Retry")))]
            ),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("trans")(
                    "with a stronger compression but it may reduce quality, especially in images."
                  )
                ) +
                "\n    "
            ),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "alert alert-warning pt-4 mb-0" },
          [
            _c("p", [
              _c("strong", { staticClass: "gap-10px d-flex" }, [
                _c("i", { staticClass: "lh-inherit far fa-info-circle" }),
                _vm._v(
                  " \n        " +
                    _vm._s("Some files did have issues") +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.currentJob.apiJob?.warnings, function (warning) {
              return _c("p", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("trans")(_vm.getTranslatedError(warning.code))
                    ) +
                    "\n    "
                ),
              ])
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }